import { type SvgIconProps } from '@mui/material';
import React from 'react';

function CalendarDueIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 -5 41 41"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_6068_71407"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="41"
      >
        <path d="M36 0H0V36H36V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_6068_71407)">
        <path
          d="M27.4167 23.6446V5.87205C27.4167 5.68545 27.3472 5.50554 27.2216 5.36748L25.3374 3.29524C25.1952 3.13892 24.9937 3.0498 24.7825 3.0498H2.61823C2.40595 3.0498 2.2036 3.13977 2.06139 3.29739L0.193204 5.36797C0.0688712 5.50577 5.09392e-05 5.68478 5.04214e-05 5.87038L0 23.6463C0 23.836 0.0718789 24.0186 0.20116 24.1574L2.06227 26.1558C2.20414 26.3081 2.40295 26.3946 2.61112 26.3946H24.7895C24.9966 26.3946 25.1946 26.3089 25.3363 26.1579L27.2135 24.1579C27.344 24.0188 27.4167 23.8353 27.4167 23.6446Z"
          fill="#FF5200"
        />
        <path
          d="M6.15527 0.9375V6.11309"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M13.708 0.9375V6.11309"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M21.2637 0.9375V6.11309"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.31308 9.33105H4.8252V11.819H7.31308V9.33105ZM9.8313 9.33105H12.3192V11.819H9.8313V9.33105ZM9.8313 14.3379H12.3192V16.8258H9.8313V14.3379ZM12.3192 19.3448H9.8313V21.8326H12.3192V19.3448ZM19.8428 9.33105H22.3307V11.819H19.8428V9.33105ZM4.8252 14.3379H7.31308V16.8258H4.8252V14.3379ZM7.31308 19.3448H4.8252V21.8326H7.31308V19.3448ZM14.8367 9.33105H17.3246V11.819H14.8367V9.33105ZM17.3246 14.3379H14.8367V16.8258H17.3246V14.3379Z"
          fill="black"
        />
        <path
          d="M25.7797 34.9101C30.8013 34.9101 34.872 30.8393 34.872 25.8178C34.872 20.7963 30.8013 16.7256 25.7797 16.7256C20.7582 16.7256 16.6875 20.7963 16.6875 25.8178C16.6875 30.8393 20.7582 34.9101 25.7797 34.9101Z"
          stroke="black"
          strokeWidth="2"
        />
        <path
          d="M25.7793 29.6631V25.85C25.7793 25.6511 25.8583 25.4604 25.999 25.3197L30.2806 21.0381"
          stroke="black"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default CalendarDueIcon;
